import { render, staticRenderFns } from "./ServicesListView.vue?vue&type=template&id=5858fefb&scoped=true&"
import script from "./ServicesListView.vue?vue&type=script&lang=js&"
export * from "./ServicesListView.vue?vue&type=script&lang=js&"
import style0 from "./ServicesListView.vue?vue&type=style&index=0&id=5858fefb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858fefb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VAlert,VContainer,VPagination})
